import { allowedModules, APP_MODULES } from 'constants/appModules';
import { useIsDev } from 'hooks/useIsDev';
import { useSelectUser } from 'redux/User/selectors';
import { UserDTO } from 'types/user';

const shouldShow = (getValues: { user: UserDTO | null; isDev: boolean }) =>
  getValues.user &&
  (getValues.isDev || allowedModules[getValues.user.profile].includes(APP_MODULES.DDX_PO));

export const useIsDevPO = () => {
  try {
    const user = useSelectUser();
    const isDev = useIsDev();
    const r = shouldShow({ user, isDev });

    return r;
  } catch (e) {
    throw e;
  }
};
